<template>
	<div class="container-summary bgWhite px-1">
		<div class="wrapper-summary d-flex flex-column">
			<p class="title-summary">Resumen de tu compra</p>
			<section class="pt-3 pb-1 px-3 fontS14">
				<div class="d-flex space-between mb-1">
					<p class="m0">SubTotal</p>
					<p class="m0"> {{getCurrencySymbol}} {{getTotalAmount | priceFormat}}</p>
				</div>
				<div class="d-flex space-between">
					<p class="m0">Envío</p>
					<p class="m0">{{getCurrencySymbol}} {{shippingCostAmount | priceFormat}}</p>
				</div>
				<div class="d-flex space-between">
					<p class="m0">Descuento</p>
					<p class="m0">{{getCurrencySymbol}} {{getClientDiscount}}</p>
				</div>
			</section>
			<section class="px-3 d-flex space-between fontS16">
				<p>Total</p>
				<p>{{getCurrencySymbol}} {{total | priceFormat}}</p>
			</section>
			<section class="container-button px-1 flex-95">
				<div class="d-flex justify-center">
					<button
						v-if="routeName === 'payment'"
						:class="[
							'btn-box',
							'uppercase',
							'btn-responsive',
							{ 'btn-disabled': invalidOrder },
						]"
						:style="`background-color:${globalColors.primary};border:1px solid ${globalColors.primary}`"
						type="button"
						:disabled="invalidOrder"
						@click="makeOrder()"
					>Pagar</button>
					<button
						v-else-if="routeName === 'buy-car'"
						:style="`background-color:${globalColors.primary};border:1px solid ${globalColors.primary}`"
						:class="[
							'btn-box uppercase',
							{ 'btn-disabled': totalProducts < 1 },
						]"
						type="button"
						:disabled="totalProducts < 1"
						@click="payAction"
					>Pasar a caja</button>
					<button
						v-else
						:class="[
              'uppercase',
							'btn-box',
							'btn-responsive',
							{ 'btn-disabled': invalidPaymentMethod },
						]"
						:style="`background-color:${globalColors.primary};border:1px solid ${globalColors.primary}`"
						type="button"
						:disabled="invalidPaymentMethod"
						@click="makeOrder(true)"
					>Finalizar Compra</button>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import lib from '@/helpers/lib';

const { getDeeper } = lib;

function total() {
	const totalAmount = (this.getTotalAmount - this.getClientDiscount) + this.shippingCostAmount;
	return Number(totalAmount.toFixed(2));
}

async function payAction() {
	if (this.token) {
		const { publicToken } = this.$store.state;
		const headers = {
			Authorization: `Bearer ${publicToken}`,
		};
		const products = this.getLocalStorage('product-select');
		const { salPriceListId } = this.getCommerceData.settings;
		const { id: companyId } = this.getCommerceData.company;
		const dataToSend = {};
		const dataProducts = products.map((item) => {
			const product = {
				id: item.id,
				name: item.name,
				description: item.description,
				code: item.code,
				urlImage: item.urlImage,
				priceListId: salPriceListId,
				quantity: item.quantity,
				warehouseId: item.warehouseProduct.warehouseId,
				unitId: item.unitId,
				amount: item.amount,
				weight: item.weight,
				price: item.price,
			};
			return product;
		});
		dataToSend.isNotLogged = false;
		dataToSend.companyId = companyId;
		dataToSend.typePreOrder = 2;
		dataToSend.order = {
			orderCode: 0,
			customer: {
				token: this.token,
			},
			products: dataProducts,
			makiId: null,
			origin: 'web',
			status: 'Pendiente',
		};
		const { data: responsePreOrder } = await this.$httpShoppyrrunn.post(
      'pre-order',
      dataToSend,
      { headers },
    );
		window.open(responsePreOrder.processUrl, '_self');
	} else {
		this.$router.push({ name: 'login' });
	}
}

async function makeOrder(finish) {
	let orderId = getDeeper('id')(this.orderSummaryInfo);
	const url = orderId ? `orders/${orderId}` : 'orders';
	const method = orderId ? 'patch' : 'post';
	if (this.token) {
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		const body = this.buildBody(finish, orderId);
		const { data: order } = await this.$httpJapi[method](url, body, { headers });
		orderId = order.id || orderId;
		await this.getOrderDetails(orderId);
		if (finish) {
			this.$message({
				message: 'Pedido realizado con éxito',
				showClose: true,
				type: 'success',
			});
			setTimeout(() => {
				this.$router.push({ name: 'order-summary' });
			}, 250);
		} else {
			this.$router.push({ name: 'payment-method' });
		}
		// this.$store.commit('SET_NEW_ADDRESS_DATA', null);
	} else {
		this.$message({
			message: 'Debe iniciar sesión para realizar el pedido',
			showClose: true,
			type: 'error',
		});
	}
}

async function getOrderDetails(id) {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const { data: response } = await this.$httpJapi.get(`orders/${id}`, { headers });
	this.$store.commit('SAVE_NEW_ORDER', response);
}

function getWarehouseId() {
	return this.flagPickUp === 1 ? this.warehouse.id : this.deliveryAddress.id;
}

function getWarehouseName() {
	return this.flagPickUp === 1 ? this.warehouse.name : this.deliveryAddress.name;
}

function customerAddressId() {
	if (this.flagPickUp === 2) {
		return null;
	}
	return this.deliveryAddress ? this.deliveryAddress.id : null;
}

function getBillindData() {
	if (this.billingData) {
		const fullBilling = Object.keys(this.billingData).every(k => this.billingData[k]);
		return fullBilling ? this.billingData : null;
	}
	return null;
}

function getWarehouseAddress() {
	return this.flagPickUp === 1 ? process.env.WAREHOUSE_ADDRESS : this.deliveryAddress.address;
}

function buildBody(finish, orderId) {
	const flagTax = this.shippingCostObject ? Boolean(this.shippingCostObject.flagTax) : false;
	const tax = this.shippingCostObject ? this.shippingCostObject.tax : 0;
	const taxAmount = this.shippingCostObject ? this.shippingCostObject.taxAmount : 0;
	const body = {
		costShipping: this.shippingCostAmount,
		costShippingFlagTax: flagTax,
		costShippingTax: tax,
		costShippingTaxAmount: taxAmount,
		customerAddressId: this.customerAddressId,
		customerAddress: this.customerAddressId ? null : this.getNewAddressData,
		customerBill: this.getBillindData,
		details: this.getDetails(this.productsSelected, orderId),
		deliveryAddress: this.deliveryAddress,
		discount: this.getClientDiscount,
		flagPickUp: this.flagPickUp,
		responsiblePickUp: this.getResponsibleData,
		subtotal: this.getTotalAmount,
		total: this.total,
		warehouseId: this.getWarehouseId,
		warehouseName: this.getWarehouseName,
		warehouseAddress: this.getWarehouseAddress,
	};
	if (this.orderSummaryInfo && this.orderSummaryInfo.flagStatusOrder) {
		body.orderStateId = this.orderSummaryInfo.orderStateId;
		body.flagStatusOrder = finish ? 3 : this.orderSummaryInfo.flagStatusOrder;
		body.wayPaymentId = finish ? this.getWayPayment.wayPayment : null;
		body.bankAccountId = finish ? this.getWayPayment.bankAccountId : null;
	} else {
		body.commerceCode = process.env.COMMERCE_CODE;
	}
	return body;
}

function getDetails(products, orderId) {
	return products.map((p) => {
		const { taxes } = p;
		const newTaxes = this.setTaxes(taxes);
		const newP = {
			alternateCode: p.alternateCode,
			brandId: getDeeper('warehouseProduct.brandId')(p) || p.brandId,
			brandName: getDeeper('warehouseProduct.brand.name')(p) || p.brandName,
			categoryId: p.categoryId,
			categoryName: getDeeper('category.name')(p) || p.categoryName,
			codeTaxes: taxes[0].code,
			description: p.description,
			discount: p.discount || 0,
			discountPercentage: p.discountPercentage || 0,
			product: {
				id: orderId ? p.productId : p.id,
				taxes: [...newTaxes],
				type: getDeeper('typeInfo.id')(p) || getDeeper('product.type')(p),
			},
			productCode: p.code || p.productCode,
			productId: orderId ? (p.productId || p.id) : p.id,
			productImage: p.urlImage || p.productImage,
			productName: p.name || p.productName,
			quantity: p.quantity,
			salePrice: p.priceDiscount || p.salePrice,
			stockQuantity: p.stock,
			taxes: newTaxes,
			unit: p.unitSelected,
			unitCode: p.unitSelected.code,
			unitConversion: 1,
			unitId: p.unitSelected.id,
			unitName: p.unitSelected.name,
			unitQuantity: p.quantity,
			warehouseId: this.getWarehouseId,
			warehouseName: this.getWarehouseName,
		};
		return newP;
	});
}

function setTaxes(taxes) {
	const newTaxes = [];
	if (!taxes && taxes.length === 0) {
		newTaxes[0] = {
			code: '01',
			codeTable: 'TABLE17',
			codePercentage: '01',
			flagSales: true,
			flagPurchases: false,
		};
	} else {
		const tax = taxes[0];
		newTaxes[0] = {
			code: tax.code,
			codeTable: tax.codeTable,
			codePercentage: tax.codePercentage,
			flagSales: Boolean(tax.flagSales),
			flagPurchases: Boolean(tax.flagPurchases),
		};
	}
	return newTaxes;
}

function routeName() {
	return this.$route.name;
}

function invalidPaymentMethod() {
	const { wayPayment } = this.getWayPayment;
	return wayPayment === 1 ? this.isVisaPayment : !wayPayment;
}

function data() {
	return {
		discount: 0,
	};
}

export default {
	name: 'purchase-summary',
	components: {
		shippingCost: () => import('@/components/buy/shippingCost'),
	},
	computed: {
		...mapGetters([
			'billingData',
			'deliveryAddress',
			'flagPickUp',
			'getClientDiscount',
			'getCurrencySymbol',
			'getNewAddressData',
			'getCommerceData',
			'getResponsibleData',
			'getTotalAmount',
			'getUserInfo',
			'getWayPayment',
			'invalidOrder',
			'isVisaPayment',
			'orderSummaryInfo',
			'productsSelected',
			'totalProducts',
			'shippingCostAmount',
			'shippingCostObject',
			'token',
			'warehouse',
		]),
		customerAddressId,
		getBillindData,
		getWarehouseAddress,
		getWarehouseId,
		getWarehouseName,
		invalidPaymentMethod,
		routeName,
		total,
	},
	data,
	methods: {
		buildBody,
		getDetails,
		getOrderDetails,
		makeOrder,
		payAction,
		setTaxes,
	},
};
</script>

<style lang="scss" scoped>
div, input, button {
	font-family: font(open-bold);
}

.border {
	border-bottom: 0.1rem solid color(leadLight);
}

.container-summary {
	margin: 2.2rem 0 0;

	@media (max-width: 768px) {
		margin: 2rem 0 0;
	}
}

.wrapper-summary {
	background-color: color(grayMedium);
	position: sticky;
	min-width: 25rem;
	top: 12%;

	@media (max-width: 500px) {
		padding: 0 2.5rem;
	}
}

.title-summary {
	border-bottom: 0.1rem solid color(leadLight);
	font-family: font(open-bold);
	font-size: size(normal);
	margin: 0;
	padding: 3rem 0.8rem 0.5rem;
	text-align: center;
}

.input {
	border: none;
	border-radius: 0.8rem;
}

.btn-apli {
	background-color: color(spaceBold);
}

.container-price {
	color: color(textGraySummary);
	margin-bottom: 1rem;
}

.price-subtotal {
	margin-bottom: 0;
}

.price-discount {
	font-family: font(open-regular);
	margin: 0;
}

.btn-discount {
	background-color: color(spaceBold);
  	border: solid 0.1rem color(spaceLight);
	border-bottom-right-radius: 0.8rem;
	border-top-right-radius: 0.8rem;
	color: color(white);
	height: 3.3rem;
	min-width: 8rem;
}


.input-descuent {
	background-color: color(white);
	border: 0.1rem solid color(leadLight);
	border-bottom-left-radius: 0.8rem;
	border-top-left-radius: 0.8rem;
	color: color(grayBold);
	padding-left: 0.8rem;
}

.flex-center {
	padding: 1.2rem;
}

.btn-box {
	border-radius: 0.8rem;
	color: color(white);
	margin-bottom: 2.2rem;
	outline: none;
	padding: 0.8rem;
	min-width: 24rem;
}

.btn-order,
.btn-back {
	background-color: color(spaceBold);
	border-radius: 0.8rem;
	color: white;
	min-width: 11rem;
	padding: 0.8rem;
}

.btn-order {
	background-color: color(defaultOrange);
}

.warehouse {
	font-size: size(medium);
	margin: 1rem 0 0;
}

.store-dispatch {
	background-color: color(border-grey);
	border-bottom: 0.1rem solid color(leadLight);
}

.btn-disabled {
	background-color: color(mediumGrey);
	color: color(defaulBlack);
	opacity: 0.5;
}

.btn-responsive {

	@media (max-width: 500px) {
		height: 4.5rem;
	}
}

.price-delivery-txt,
.price-delivery-amount {
	margin: 0;
}

.discount-amount {
	font-family: font(open-regular);
}
</style>



// WEBPACK FOOTER //
// purchaseSummary.vue?7a9b9ec3